<template>
  <div class="control-unit">
    <p class="control-unit__title">
      <span>{{ title }}</span>

      <Tooltip
        v-if="tooltip"
        class="control-unit__tooltip"
        :text="tooltip"
        :key="tooltip"
      />
    </p>

    <div class="control-unit__content">
      <slot></slot>
    </div>

    <p
      v-if="description"
      class="control-unit__description"
    >
      {{ description }}
    </p>
  </div>
</template>

<script>
import Tooltip from '@/components/Tooltip.vue';

export default {
  components: {
    Tooltip,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss">
.control-unit {
  $this: 'control-unit';

  &__title {
    font-size: 14px;
    margin-bottom: 10px;
  }

  &__tooltip {
    margin-left: 5px;
  }

  &__content {
    margin-bottom: 10px;
  }

  &__description {
    font-size: 12px;
  }
}
</style>
